import { Advance, Asset, Company, Loan, Note, TAssetId, TCompanyId, TLoanId } from '/src/lib/models';

/**
 * List Advances API request.
 */
export type TListAdvancesRequest = {
  /**
   * Only show this Loan's Advances
   */
  loanId?: TLoanId;
  /**
   * Only show this Lender's Advances
   */
  lenderId?: TCompanyId;
  /**
   * Only show this Company's Advances
   */
  companyId?: TCompanyId;
};

/**
 * List Advances API response.
 */
export type TListAdvancesResponse = Advance[];

/**
 * Get Advance API response.
 */
export type TGetAdvanceResponse = Advance;

/**
 * Create Advance page data form.
 */
export type CreateAdvanceForm = {
  /**
   * Advance name
   */
  name: string;
  /**
   * Advance amount
   */
  amount: string;
  /**
   * Loan to take out Advances against
   */
  loan?: Loan;
  /**
   * Company requesting the Advance
   */
  company?: Company;
  /**
   * Date the Advance requst was submitted
   */
  dateRequested: Date;
  /**
   * Origination fee
   */
  originationFee: number;
  /**
   * Advance notes
   */
  notes: Note[];
  /**
   * Date the Advance was fulfilled
   */
  dateFulfilled?: Date;
  /**
   * Effective date of this Advance
   */
  effectiveDate: string;
  /**
   * List of related documents
   */
  files: string[];
  /**
   * Asset to take out Advances against
   */
  asset?: Asset;
};

/**
 * Create Advance API request.
 */
export type TCreateAdvanceRequest = {
  /**
   * Advance name
   */
  name: string;
  /**
   * Advance amount
   */
  amount: number;
  /**
   * Loan to take out Advances against
   */
  loan: TLoanId;
  /**
   * Company requesting the Advance
   */
  company: TCompanyId;
  /**
   * Date the Advance requst was submitted
   */
  dateRequested: string;
  /**
   * Origination fee
   */
  originationFee: number;
  /**
   * Advance notes
   */
  notes: Note[];
  /**
   * Date the Advance was fulfilled
   */
  dateFulfilled: string;
  /**
   * Effective date of this Advance
   */
  effectiveDate: string;
  /**
   * List of related documents
   */
  files: string[];
  /**
   * Asset to take out Advances against
   */
  assetId?: TAssetId;
};

/**
 * Create Advance API response.
 */
export type TCreateAdvanceResponse = Advance;

/**
 * Update Advance page form data.
 */
export type UpdateAdvanceForm = Advance;

/**
 * Update Advance API request.
 */
export type TUpdateAdvanceRequest = Advance;

/**
 * Update Advance API response.
 */
export type TUpdateAdvanceResponse = Advance;

/**
 * Delete Advance API response.
 */
export type TDeleteAdvanceResponse = Advance;
